import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { FmsService } from "src/app/services/fms.service";
import { AccordionModule } from "@storeblocks/accordion-ng";

interface ArticlesFaq {
  trackId: string;
  title: string;
  content: string;
}

@Component({
  selector: "app-articles-faq",
  templateUrl: "./articles-faq.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AccordionModule],
})
export class ArticlesFaqComponent {
  private readonly fmsService = inject(FmsService);

  public readonly list: ArticlesFaq[];

  constructor() {
    this.list = this.fmsService.getJSON<ArticlesFaq[]>("articlesFaq.list");
  }
}
